import React, { useState, useContext, useEffect } from "react";
import { Paths } from "Paths";
import { useHistory } from "react-router-dom";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import { SigninModal } from "pages/signin/SigninModal";
import { SigninContext } from "pages/signin/SigninContext";
import { UserApi } from "api/UserApi";
import { User } from "api/entities/User";
import * as CommonConstants from "utilities/CommonConstants";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    menuitem: {
        padding: theme.spacing(1),
        textAlign: `center`,
        marginLeft: `-8px`,
        minWidth: `8%`,
    },
    tabs: {
        flexGrow: 1,
    },
    signinButton: {
        marginRight: `-10px`,
        textTransform: `none`,
    },
}));

export const Navbar: React.FC = () => {
    const classes = useStyles();
    const history = useHistory();
    const [menuId, setMenuId] = React.useState(0);
    const [isOpenForSigninModal, setOpenForSigninModal] = useState<boolean>(false);

    // ログインユーザ情報取得
    const isSignin = async () => {
        const user: User = await UserApi.getUser();
        return user.signin;
    };

    const handleChange = (event: React.ChangeEvent<Record<string, unknown>>, newMenuId: number) => {
        setMenuId(newMenuId);
    };
    const { success, setSuccess } = useContext(SigninContext);
    const [displayStatus, setDisplayStatus] = useState<string>(``);

    useEffect(() => {
        const execute = async () => {
            setDisplayStatus((await isSignin()) ? `SignOut` : `SignIn`);
        };
        execute();
    }, [success]);

    const onClickSignin = () => {
        setOpenForSigninModal(false);
    };

    const onClickSign = async () => {
        if (await isSignin()) {
            // サインアウト処理
            sessionStorage.removeItem(CommonConstants.SESSION_KEY_TOKEN);
            setDisplayStatus(`SignIn`);
            setSuccess(false);
        } else {
            // サインイン処理
            setOpenForSigninModal(true);
        }
    };

    return (
        <div className={`${classes.root} noPrint`}>
            <SigninModal
                isOpen={isOpenForSigninModal}
                onClickCancel={() => {
                    setOpenForSigninModal(false);
                }}
                onClickSignin={onClickSignin}
                setDisplayStatus={setDisplayStatus}
            />
            <AppBar position="static">
                <Toolbar>
                    {success && (
                        <>
                            <Tabs
                                value={menuId}
                                onChange={handleChange}
                                className={classes.tabs}
                                TabIndicatorProps={{
                                    style: {
                                        backgroundColor: `#ffffff`,
                                    },
                                }}
                            >
                                <Tab
                                    label="予約"
                                    onClick={() => history.push(Paths.top)}
                                    className={classes.menuitem}
                                    style={{ outline: 0 }}
                                />
                            </Tabs>
                            <Button
                                variant="outlined"
                                color="inherit"
                                onClick={onClickSign}
                                className={classes.signinButton}
                            >
                                {displayStatus}
                            </Button>
                        </>
                    )}
                </Toolbar>
            </AppBar>
        </div>
    );
};
